import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { CARDS_BOX, CARDS_TYPE } from '../../enums/cardTypes';
import { useIdsGenerator } from '../../hooks/useIdsGenerator';
import { cardsStore } from '../../store/cardsStore';

export const RoundCards = observer(() => {
  const { tableCards } = cardsStore;
  const cardsIds = useIdsGenerator(CARDS_BOX);
  const isShowDisable = useMemo(() => {
    return tableCards.some((item) => item.isWin);
  }, [tableCards]);

  return (
    <>
      {/*  /!*add rotate-cards, win class*!/ */}
      {CARDS_BOX.map((item, index) => (
        <div
          key={cardsIds[index]}
          className={`${isMobile() ? 'tb-game-mobile-cards-wrp' : 'tb-game-cards-item-wrp'}`}
        >
          <div
            className={`tb-game-cards-item ${
              isShowDisable &&
              tableCards[index]?.isDisabled &&
              tableCards[index].isDisabled &&
              !isMobile()
                ? 'disabled'
                : ''
            } ${tableCards[index]?.isWin && tableCards[index].isWin ? 'win' : ''} ${
              tableCards[index] && !tableCards[index].close ? '' : 'rotate-cards'
            }`}
          >
            <div
              className={`tb-card-front 
              ${tableCards[index] ? CARDS_TYPE[tableCards[index].card] : ''}
              `}
            />
            <div className='tb-card-back' />
          </div>
        </div>
      ))}
    </>
  );
});
